import Swal from "sweetalert2";
import { Utils } from "./utils.js";
import { Api } from "../api/api.js";

export const UserUtil = {
  /**
   * Returns a possible default address
   * @param {*} userId
   * @param {*} type
   */
  getDefaultAddresses: async (userId) => {
    const response = await Api.getAddressByUser(userId);
    if (response?.data?.data) {
      let addresses = response?.data?.data;
      const billingAddresses = addresses.filter(
        (item) => item.type == "billing"
      );
      const shippingAddresses = addresses.filter(
        (item) => item.type == "shipping"
      );
      //now get the default
      let items = shippingAddresses.filter((item) => item.isDefault == true);

      let defaultShippingAddress = null;
      if (items.length > 0) {
        // get at least the first item
        defaultShippingAddress = items[0];
      } else {
        // just get the first item
        defaultShippingAddress = shippingAddresses[0];
      }

      //process the billing address
      items = billingAddresses.filter((item) => item.isDefault == true);

      let defaultBillingAddress = null;
      if (items.length > 0) {
        // get at least the first item
        defaultBillingAddress = items[0];
      } else {
        // just get the first item
        defaultBillingAddress = billingAddresses[0];
      }

      return {
        billingAddress: defaultBillingAddress,
        shippingAddress: defaultShippingAddress,
      };
    }

    return {
      billingAddress: null,
      shippingAddress: null,
    };
  },
};
